import React from 'react';
import { Col } from 'antd';
import { TableDes, TableRow, TableView } from './POSummaryStyle';

const PaymentSummary = (props) => {
  const { subTotal, total, taxAmount, discountAmount, recordList } = props;

  return (
    <TableView
    //   style={{
    //     width: 300,
    //     padding: 10,
    //     borderRadius: 10,
    //     border: '1px solid #d9d9d9',
    //     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    //   }}
    >
      <TableRow>
        <Col span={16}>
          <TableDes>Total Products</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes>{recordList.length}</TableDes>
        </Col>
      </TableRow>
      <TableRow>
        <Col span={16}>
          <TableDes>Total Amount</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes>{subTotal}</TableDes>
        </Col>
      </TableRow>
      <TableRow>
        <Col span={16}>
          <TableDes>Total Tax</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes>{taxAmount}</TableDes>
        </Col>
      </TableRow>
      <TableRow>
        <Col span={16}>
          <TableDes>Discount</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes>{discountAmount}</TableDes>
        </Col>
      </TableRow>
      <TableRow>
        <Col span={16}>
          <TableDes style={{ color: '#1890ff', fontWeight: 'bold' }}>Grand Total</TableDes>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <TableDes style={{ color: '#1890ff', fontWeight: 'bold' }}>{total}</TableDes>
        </Col>
      </TableRow>
    </TableView>
  );
};

export default PaymentSummary;
